import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { SharedModule } from '../../../shared/shared.module';
import { DpLancamentoRubricasComponent } from './dp-lancamento-rubricas.component';

@NgModule({
  declarations: [DpLancamentoRubricasComponent],
  exports: [DpLancamentoRubricasComponent],
  imports: [CommonModule, FormsModule, PoModule, SharedModule]
})
export class DpLancamentoRubricasModule {}
